import { Menu, MenuItem, Skeleton, Typography } from "@mui/material";
import {
  Box,
  MuiLoadingButton,
  // FilterAltRounded,
  KeyboardArrowDownRounded,
  KeyboardArrowRightRounded,
} from "components/common";
import { SORT_OPTIONS } from "constants/products/constants";
// import { MouseEvent, useState } from "react";
import { Link } from "react-router-dom";
import useProductsFunctions from "../ts/useProductsFunctions";
import { usePathname } from "hooks/use-pathname";
import { ProductHeaderWrapper } from "./index.styled";

export default function ProductsHeader() {
  const pathname = usePathname();
  const isCategory = pathname.split("/")[1] === "category";
  const isBrand = pathname.split("/")[1] === "brand";
  
  const {
    loading,
    sort,
    search,
    data,
    first,
    second,
    // handleFilterDrawerToggle,
    handleSort,
    handleClick,
    menuOpen,
    anchorEl,
    handleClose,
  } = useProductsFunctions();

  const formatParam = (param: string | undefined) =>
    param ? param.replace(/-/g, " ") : "";
  return (
    <ProductHeaderWrapper>
      <Box
        display="flex"
        alignItems={{ xs: "start", md: "center" }}
        justifyContent={{ xs: "flex-start", md: "space-between" }}
        flexDirection={{ xs: "column", md: "row" }}
      >
        <Box>
          <Box component="h2" className="title">
            {first && second
              ? `${formatParam(first)}: ${formatParam(second)}`
              : first
              ? formatParam(first)
              : search
              ? `Search results for "${search}"`
              : "All Products"}
          </Box>
          <Box className="nav">
            <Link className="home-link" to="/">
              Home
            </Link>{" "}
            {first && (
              <>
                <KeyboardArrowRightRounded />
                {isCategory ? (
                  <span className="breadcrumb-link">{formatParam(first)}</span>
                ) : isBrand ? (
                  <Link className="home-link" to={`/brand/${first}`}>
                    {formatParam(first)}
                  </Link>
                ) : (
                  <Link className="home-link" to={`/products/${first}`}>
                    {formatParam(first)}
                  </Link>
                )}
              </>
            )}
            {second && (
              <>
                <KeyboardArrowRightRounded />
                {isBrand ? (
                  <Link className="home-link" to={`/brand/${first}/${second}`}>
                    {formatParam(second)}
                  </Link>
                ) : (
                  <Link className="home-link" to={`/products/${first}/${second}`}>
                    {formatParam(second)}
                  </Link>
                )}
              </>
            )}
            {search && (
              <>
                <KeyboardArrowRightRounded />
                <span className="breadcrumb-link">Search: {search}</span>
              </>
            )}
          </Box>
        </Box>
        <Box className="right">
          <Typography
            sx={{
              color: "#666666",
            }}
          >
            {loading ? (
              <Skeleton width={150} />
            ) : (
              `Showing all ${data?.length} results`
            )}
          </Typography>
          <Box>
            <MuiLoadingButton
              endIcon={
                <KeyboardArrowDownRounded
                  sx={{
                    transform: menuOpen ? "rotate(180deg)" : "rotate(0deg)",
                  }}
                />
              }
              onClick={handleClick}
              disabled={loading}
              disableElevation
            >
              {loading ? <Skeleton width={100} /> : sort.label}
            </MuiLoadingButton>
            <Menu
              anchorEl={anchorEl}
              open={menuOpen}
              onClose={handleClose}
              elevation={0}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
              disableScrollLock
            >
              {SORT_OPTIONS.map((option) => (
                <MenuItem
                  key={option.value}
                  value={option.value}
                  onClick={() => handleSort(option)}
                >
                  {option.label}
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Box>
      </Box>
      {/* <Box className="main"> */}
      {/* <MuiLoadingButton
          startIcon={<FilterAltRounded />}
          onClick={handleFilterDrawerToggle}
        >
          Show Filters
        </MuiLoadingButton> */}
      {/* <Box className="right">
          <Box
            sx={{
              color: "#666666",
            }}
          >
            Showing all {data?.length} results
          </Box>
          <Box>
            <MuiLoadingButton
              endIcon={
                <KeyboardArrowDownRounded
                  sx={{
                    transform: menuOpen ? "rotate(180deg)" : "rotate(0deg)",
                  }}
                />
              }
              onClick={handleClick}
              disableElevation
            >
              {sort.label}
            </MuiLoadingButton>
            <Menu
              anchorEl={anchorEl}
              open={menuOpen}
              onClose={handleClose}
              elevation={0}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
              disableScrollLock
            >
              {SORT_OPTIONS.map((option) => (
                <MenuItem
                  key={option.value}
                  value={option.value}
                  onClick={() => handleSort(option)}
                >
                  {option.label}
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Box>
      </Box> */}
    </ProductHeaderWrapper>
  );
}
